import {
  removeRoleAssignment,
  removeRoleAssignments,
  resetEditRoleAssignmentData,
  setIsEditRoleAssignment,
  setRoleAssignmentEditingData
} from "../store/userManagement/userManagementActions";
import { IManageUserDetail } from "../interfaces/user/UserInterfaces";
import { Dispatch } from "react";
import { AnyAction } from "@reduxjs/toolkit";
import { History } from "history";
import { NavigateFunction } from "react-router-dom";

class AddRoleAssignmentService {
  editRoleRoute: string;
  dispatch: Dispatch<AnyAction>;
  navigate: NavigateFunction;
  constructor(
    editRoleRoute: string,
    dispatch: Dispatch<AnyAction>,
    navigate: NavigateFunction
  ) {
    this.editRoleRoute = editRoleRoute;
    this.dispatch = dispatch;
    this.navigate = navigate;
  }

  onAddRoleAssignment = () => {
    this.dispatch(resetEditRoleAssignmentData());
    this.dispatch(setIsEditRoleAssignment(false));
    this.navigate(this.editRoleRoute, {state: {fromRoleAssignment: true}});
  }

  onEditRoleAssignment = (roleAssignment: IManageUserDetail) => {
    this.dispatch(resetEditRoleAssignmentData());
    this.dispatch(setIsEditRoleAssignment(true));
    this.dispatch(setRoleAssignmentEditingData(roleAssignment));
    this.navigate(this.editRoleRoute, {state: {fromRoleAssignment: true}});
  }

  onRemoveRoleAssignment = (userDetail: IManageUserDetail) => {
    this.dispatch(removeRoleAssignment({
      role: userDetail.role,
      isTechUser: userDetail.isTechUser,
      isPsdUser: userDetail.isPsdUser,
      isMfgUser: userDetail.isMfgUser,
      isRCEditor: userDetail.isRCEditor
    }))
  }

  onRemoveRoleAssignments = () => {
    this.dispatch(removeRoleAssignments());
  }
}

export { AddRoleAssignmentService }
